module.exports = __webpack_public_path__ + "img/shipo-icon-return-cargo.ce8c0c30.svg";